<div class="accordion" [ngClass]=" adClass" [id]="accordionID">
    <ng-content></ng-content>
</div>